import { useEffect, useState } from 'react';
import { fmtVND, fmtNum, fmtDate, fmtDateTime } from '../utils/format';
import { listTotalOrders } from '../api/totalOrders';

const thisMonth = () => new Date().toISOString().slice(0, 7);

// Phân loại web mua hộ (site_code) — dùng cho tuyến JP.
const SITE_CATEGORY = {
  MER_JP: 'Mercari',
  mercari: 'Mercari',
  JP_YAHOO_AUC: 'Yahoo Auction',
};
// Phân loại theo tuyến (route_code) — các tuyến US tính theo tuyến.
const ROUTE_CATEGORY = {
  USEBAY: 'Ebay',
  USSA: 'Ebay',
  USMH: 'Site ngoài US',
  USSITEKHAC: 'Site ngoài US',
};
// Quy tắc: tuyến US -> theo tuyến; tuyến JP -> theo web mua hộ, web lạ thì "Site khác".
function categoryOf(site, route) {
  if (ROUTE_CATEGORY[route]) return ROUTE_CATEGORY[route];
  if (SITE_CATEGORY[site]) return SITE_CATEGORY[site];
  if (route && route.toUpperCase().startsWith('JP')) return 'Site khác';
  return site || route || '—';
}

// Đổi tên hiển thị trạng thái cho khớp FunnyTask.
const STATUS_LABEL = {
  'Đã xác nhận mua hàng': 'Chờ mua hàng',
  'Đã đặt hàng thành công!': 'Chờ mua hàng',
};
const statusOf = (s) => STATUS_LABEL[s] || s || '—';

export default function TotalOrdersPage({ embedded = false }) {
  const [month, setMonth] = useState(thisMonth());
  const [search, setSearch] = useState('');
  const [route, setRoute] = useState('');
  const [site, setSite] = useState('');
  const [data, setData] = useState({ items: [], total: 0, totalPages: 1, routes: [], sites: [] });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(200);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    listTotalOrders({ month, search, route, site, page, limit: pageSize })
      .then(setData)
      .finally(() => setLoading(false));
  }, [month, search, route, site, page, pageSize]);

  // Đổi bộ lọc -> về trang 1.
  useEffect(() => setPage(1), [month, search, route, site, pageSize]);

  return (
    <>
      {!embedded && (
        <div className="page-head">
          <div>
            <h2>Tổng đơn hàng</h2>
            <div className="sub">Lấy từ màn Tổng đơn hàng SocSon (đồng bộ qua extension).</div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="row between" style={{ marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <div>
            <h3 style={{ margin: 0 }}>📦 Danh sách đơn ({data.total})</h3>
            {data.lastSyncedAt && (
              <div className="small muted" style={{ marginTop: 2 }}>
                Cập nhật lần cuối: {fmtDateTime(data.lastSyncedAt)}
              </div>
            )}
          </div>
          <div className="row" style={{ gap: 8, flexWrap: 'wrap' }}>
            <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} style={{ width: 'auto' }} />
            <select value={route} onChange={(e) => setRoute(e.target.value)} style={{ width: 'auto' }}>
              <option value="">Tất cả tuyến</option>
              {(data.routes || []).map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
            <select value={site} onChange={(e) => setSite(e.target.value)} style={{ width: 'auto' }}>
              <option value="">Tất cả web</option>
              {(data.sites || []).map((s) => (
                <option key={s} value={s}>
                  {categoryOf(s)} ({s})
                </option>
              ))}
            </select>
            <input
              style={{ width: 200 }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="🔍 Tìm mã đơn / trạng thái…"
            />
            <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))} style={{ width: 'auto' }}>
              {[100, 200, 500].map((n) => (
                <option key={n} value={n}>
                  {n}/trang
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th>Mã đơn</th>
              <th>Trạng thái</th>
              <th className="c">Phân loại</th>
              <th className="r">Tổng tiền</th>
              <th>Ngày tạo</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="empty">
                  Đang tải...
                </td>
              </tr>
            ) : data.items.length ? (
              data.items.map((o) => (
                <tr key={o._id}>
                  <td>
                    <code style={{ color: 'var(--accent2)' }}>{o.code}</code>
                  </td>
                  <td>{statusOf(o.statusLabel)}</td>
                  <td className="c">
                    <span className="chip doing">{categoryOf(o.siteCode, o.routeCode)}</span>
                  </td>
                  <td className="r">
                    <b style={{ color: 'var(--accent2)' }}>{fmtVND(o.subtotal || 0)}</b>
                  </td>
                  <td className="small">{o.createdDate ? fmtDate(o.createdDate) : '—'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="empty">
                  Chưa có đơn nào — chạy “Đẩy tổng đơn hàng” ở màn Đồng bộ.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>

        {data.totalPages > 1 && (
          <div className="row between" style={{ marginTop: 12 }}>
            <span className="small muted">
              Trang {data.page}/{data.totalPages} · {data.total} đơn
            </span>
            <div className="row" style={{ gap: 8 }}>
              <button className="btn ghost sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
                ‹ Trước
              </button>
              <button
                className="btn ghost sm"
                disabled={page >= data.totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Sau ›
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
